import React from 'react'
import { ClientTypeTitle } from '../../../../../../constants/ClientTypes'
import CustomButton from '../../../../CustomButton'
import './style.sass'

const ClientEmptyState = ({ clientType, onAddClientClicked, disabled }) => {
  const clientTypeTitle = ClientTypeTitle(clientType)

  return (
    <div className="client-empty-state-container">
      <p>You have not added a <b>{clientTypeTitle}</b> client, would you like to add one?</p>
      <CustomButton
        onClick={onAddClientClicked}
        buttonText={`Add ${clientTypeTitle} client`}
        className={`btn btn-fill`}
        disabled={disabled}
      />
    </div>
  )
}

export default ClientEmptyState
